import Vue from 'vue'
import '../i18n/index.js'

const { i18n } = Vue

export const serviceTypes = [
    { value: 'VISIT', name: i18n?.translate('type.VISIT')},
    { value: 'VISIT_PREMIUM', name: i18n?.translate('type.VISIT_PREMIUM')},
    { value: 'PHOTOGRAPHY', name: i18n?.translate('type.PHOTOGRAPHY')},
    { value: 'PHOTOGRAPHY_PREMIUM', name: i18n?.translate('type.PHOTOGRAPHY_PREMIUM')},
    { value: 'PHOTOGRAPHY_360', name: i18n?.translate('type.PHOTOGRAPHY_360')},
    { value: 'KEY_DELIVERY', name: i18n?.translate('type.KEY_DELIVERY')},
    { value: 'INSPECTION', name: i18n?.translate('type.INSPECTION')},
    { value: 'DISPLACEMENT', name: i18n?.translate('type.DISPLACEMENT')},
    { value: 'DRONE', name: i18n?.translate('type.DRONE')},
    { value: 'LOFT_VISIT', name: i18n?.translate('type.LOFT_VISIT')},
    { value: 'INSPECTION_ENTRANCE', name: i18n?.translate('type.INSPECTION_ENTRANCE')},
    { value: 'INSPECTION_ENTRANCE_PREMIUM', name: i18n?.translate('type.INSPECTION_ENTRANCE_PREMIUM')},
    { value: 'INSPECTION_EXIT', name: i18n?.translate('type.INSPECTION_EXIT')},
    { value: 'INSPECTION_EXIT_GOLD', name: i18n?.translate('type.INSPECTION_EXIT_GOLD')},
    { value: 'INSPECTION_EXIT_PREMIUM', name: i18n?.translate('type.INSPECTION_EXIT_PREMIUM')},
    { value: 'INSPECTION_INTERMEDIARY', name: i18n?.translate('type.INSPECTION_INTERMEDIARY')},
    { value: 'INSPECTION_DELIVERY', name: i18n?.translate('type.INSPECTION_DELIVERY')},
    { value: 'INSPECTION_MEASUREMENT', name: i18n?.translate('type.INSPECTION_MEASUREMENT')},
    { value: 'INSPECTION_AUDITANCE', name: i18n?.translate('type.INSPECTION_AUDITANCE')},
    { value: 'REINSPECTION', name: i18n?.translate('type.REINSPECTION')},
    { value: 'REINSPECTION_HAUSEFUL', name: i18n?.translate('type.REINSPECTION_HAUSEFUL')},
    { value: 'TECHNICAL_SKETCH', name: i18n?.translate('type.TECHNICAL_SKETCH')},
    { value: 'TECHNICAL_SKETCH_PLUS', name: i18n?.translate('type.TECHNICAL_SKETCH_PLUS')},
    { value: 'PLANNING', name: i18n?.translate('type.PLANNING')},
    { value: 'IMAGE_EDITING', name: i18n?.translate('type.IMAGE_EDITING')},
    { value: 'REALTY_SUGGESTION', name: i18n?.translate('type.REALTY_SUGGESTION')},
    { value: 'REMOTE_VISIT', name: i18n?.translate('type.REMOTE_VISIT')},
    { value: 'SKETCH', name: i18n?.translate('type.SKETCH')},
    { value: 'INSPECTION_ENTRANCE_PLUS', name: i18n?.translate('type.INSPECTION_ENTRANCE_PLUS')},
    { value: 'INSPECTION_EXIT_PLUS', name: i18n?.translate('type.INSPECTION_EXIT_PLUS')},
    { value: 'INSPECTION_MINI', name: i18n?.translate('type.INSPECTION_MINI')},
    { value: 'VISIT_GOLD', name: i18n?.translate('type.VISIT_GOLD')},
    { value: 'INSPECTION_CONSTRUCTION_INTERMEDIARY', name: i18n?.translate('type.INSPECTION_CONSTRUCTION_INTERMEDIARY')},
    { value: 'INSPECTION_CONSTRUCTION_FINAL', name: i18n?.translate('type.INSPECTION_CONSTRUCTION_FINAL')},
    { value: 'INSPECTION_CONFERRING_ENTRANCE', name: i18n?.translate('type.INSPECTION_CONFERRING_ENTRANCE')},
    { value: 'INSPECTION_ENTRANCE_HOUSEVIEW', name: i18n?.translate('type.INSPECTION_ENTRANCE_HOUSEVIEW')},
    { value: 'INSPECTION_EXIT_HOUSEVIEW', name: i18n?.translate('type.INSPECTION_EXIT_HOUSEVIEW')},
    { value: 'MAPPING_FOR_EVALUATION', name: i18n?.translate('type.MAPPING_FOR_EVALUATION')},
    { value: 'DELIVERY', name: i18n?.translate('type.DELIVERY')},
    { value: 'INSPECTION_POST_INSTALLATION', name: i18n?.translate('type.INSPECTION_POST_INSTALLATION')},
    { value: 'INSPECTION_AND_ESTIMATE', name: i18n?.translate('type.INSPECTION_AND_ESTIMATE')},
    { value: 'INSPECTION_SHED', name: i18n?.translate('type.INSPECTION_SHED')},
    { value: 'INSPECTION_SHED_EXIT', name: i18n?.translate('type.INSPECTION_SHED_EXIT')},
    { value: 'INSPECTION_IMOBMIX_ENTRANCE', name: i18n?.translate('type.INSPECTION_IMOBMIX_ENTRANCE')},
    { value: 'INSPECTION_IMOBMIX_EXIT', name: i18n?.translate('type.INSPECTION_IMOBMIX_EXIT')},
    { value: 'PHOTOGRAPHY_PLUS', name: i18n?.translate('type.PHOTOGRAPHY_PLUS')},
    { value: 'PHOTOGRAPHY_HAUSEFUL', name: i18n?.translate('type.PHOTOGRAPHY_HAUSEFUL')},
    { value: 'PHOTOGRAPHY_HOME_STAGING', name: i18n?.translate('type.PHOTOGRAPHY_HOME_STAGING')},
    { value: 'VISIT_AND_PHOTOS', name: i18n?.translate('type.VISIT_AND_PHOTOS')},
    { value: 'VISIT_LIGHT', name: i18n?.translate('type.VISIT_LIGHT')},
    { value: 'VISIT_SALE', name: i18n?.translate('type.VISIT_SALE')},
    { value: 'TRAINING', name: i18n?.translate('type.TRAINING')},
    { value: 'MISSION', name: i18n?.translate('type.MISSION')},
    { value: 'PHOTOGRAPHY_PREMIUM_PLUS_360', name: i18n?.translate('type.PHOTOGRAPHY_PREMIUM_PLUS_360')},
    { value: 'OBSERVED_TRAINING', name: i18n?.translate('type.OBSERVED_TRAINING')},
    { value: 'DUMP', name: i18n?.translate('type.DUMP')},
    { value: 'EVICTION', name: i18n?.translate('type.EVICTION')},
    { value: 'INSPECTION_TEST', name: i18n?.translate('type.INSPECTION_TEST')},
    { value: 'TERMINATION', name: i18n?.translate('type.TERMINATION')},
    { value: 'RENT_OUT', name: i18n?.translate('type.RENT_OUT')},
    { value: 'RENT_OUT_DUDA', name: i18n?.translate('type.RENT_OUT_DUDA')},
    { value: 'INSPECTION_IB_ENTRANCE', name: i18n?.translate('type.INSPECTION_IB_ENTRANCE')},
    { value: 'INSPECTION_IB_EXIT', name: i18n?.translate('type.INSPECTION_IB_EXIT')},
    { value: 'INSPECTION_MINI_EXIT', name: i18n?.translate('type.INSPECTION_MINI_EXIT')},
    { value: 'INSPECTION_MINI_EXIT_GOLD', name: i18n?.translate('type.INSPECTION_MINI_EXIT_GOLD')},
    { value: 'INSPECTION_MINI_EXIT_PLUS', name: i18n?.translate('type.INSPECTION_MINI_EXIT_PLUS')},
    { value: 'INSPECTION_MINI_ENTRANCE_GOLD', name: i18n?.translate('type.INSPECTION_MINI_ENTRANCE_GOLD')},
    { value: 'INSPECTION_MINI_ENTRANCE_PLUS', name: i18n?.translate('type.INSPECTION_MINI_ENTRANCE_PLUS')},
    { value: 'INSPECTION_ENTRANCE_BACKLOG', name: i18n?.translate('type.INSPECTION_ENTRANCE_BACKLOG')},
    { value: 'INSPECTION_EXIT_BACKLOG', name: i18n?.translate('type.INSPECTION_EXIT_BACKLOG')},
    { value: 'INSPECTION_ENTRANCE_ANTICIPATION', name: i18n?.translate('type.INSPECTION_ENTRANCE_ANTICIPATION')},
    { value: 'INSPECTION_INSURER', name: i18n?.translate('type.INSPECTION_INSURER')},
    { value: 'DEBT_NOTIFICATION', name: i18n?.translate('type.DEBT_NOTIFICATION')},
    { value: 'PHOTOGRAPHY_PLUS_FOTOP', name: i18n?.translate('type.PHOTOGRAPHY_PLUS_FOTOP')},
    { value: 'PHOTOGRAPHY_PREMIUM_FOTOP', name: i18n?.translate('type.PHOTOGRAPHY_PREMIUM_FOTOP')},
    { value: 'INSPECTION_ENTRANCE_GOLD_ONE_OFF', name: i18n?.translate('type.INSPECTION_ENTRANCE_GOLD_ONE_OFF')},
    { value: 'INSPECTION_EXIT_GOLD_ONE_OFF', name: i18n?.translate('type.INSPECTION_EXIT_GOLD_ONE_OFF')},
    { value: 'ROUTINE_INSPECTION', name: i18n?.translate('type.ROUTINE_INSPECTION')},
    { value: 'INGOING_INSPECTION', name: i18n?.translate('type.INGOING_INSPECTION')},
    { value: 'OUTGOING_INSPECTION', name: i18n?.translate('type.OUTGOING_INSPECTION')},
    { value: 'VIRTUAL_TOUR', name: i18n?.translate('type.VIRTUAL_TOUR')},
    { value: 'INGOING_INSPECTION_VIRTUAL_TOUR', name: i18n?.translate('type.INGOING_INSPECTION_VIRTUAL_TOUR')},
    { value: 'REVISION_INSPECTION', name: i18n?.translate('type.REVISION_INSPECTION')},
    { value: 'MEASURE_AND_CAPTURE', name: i18n?.translate('type.MEASURE_AND_CAPTURE')},
    { value: 'INGOING_APARTMENT_THREE_BEDS', name: i18n?.translate('type.INGOING_APARTMENT_THREE_BEDS')},
    { value: 'INGOING_APARTMENT_FOUR_PLUS_BEDS', name: i18n?.translate('type.INGOING_APARTMENT_FOUR_PLUS_BEDS')},
    { value: 'INGOING_HOUSE_THREE_BEDS', name: i18n?.translate('type.INGOING_HOUSE_THREE_BEDS')},
    { value: 'INGOING_HOUSE_FOUR_BEDS', name: i18n?.translate('type.INGOING_HOUSE_FOUR_BEDS')},
    { value: 'INGOING_HOUSE_FIVE_PLUS_BEDS', name: i18n?.translate('type.INGOING_HOUSE_FIVE_PLUS_BEDS')},
    { value: 'OUTGOING_APARTMENT_THREE_BEDS', name: i18n?.translate('type.OUTGOING_APARTMENT_THREE_BEDS')},
    { value: 'OUTGOING_APARTMENT_FOUR_PLUS_BEDS', name: i18n?.translate('type.OUTGOING_APARTMENT_FOUR_PLUS_BEDS')},
    { value: 'OUTGOING_HOUSE_THREE_BEDS', name: i18n?.translate('type.OUTGOING_HOUSE_THREE_BEDS')},
    { value: 'OUTGOING_HOUSE_FOUR_BEDS', name: i18n?.translate('type.OUTGOING_HOUSE_FOUR_BEDS')},
    { value: 'OUTGOING_HOUSE_FIVE_PLUS_BEDS', name: i18n?.translate('type.OUTGOING_HOUSE_FIVE_PLUS_BEDS')},
    { value: 'QUESTIONNAIRE', name: i18n?.translate('type.QUESTIONNAIRE')},
    { value: 'GONDOLA', name: i18n?.translate('type.GONDOLA')},
    { value: 'INSPECTION_ENTRANCE_SHORTSTAY', name: i18n?.translate('type.INSPECTION_ENTRANCE_SHORTSTAY')},
    { value: 'INSPECTION_EXIT_SHORTSTAY', name: i18n?.translate('type.INSPECTION_EXIT_SHORTSTAY')},
    { value: 'INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.INGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.INGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.INGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.INGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.INGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.OUTGOING_APARTMENT_THREE_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.OUTGOING_APARTMENT_FOUR_PLUS_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.OUTGOING_HOUSE_THREE_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.OUTGOING_HOUSE_FOUR_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.OUTGOING_HOUSE_FIVE_PLUS_BEDS_PLUS_VIRTUAL_TOUR')},
    { value: 'HAUSEFUL_ENTRANCE', name: i18n?.translate('type.HAUSEFUL_ENTRANCE')},
    { value: 'HAUSEFUL_EXIT', name: i18n?.translate('type.HAUSEFUL_EXIT')},
    { value: 'HAUSEFUL_EXIT_WITHOUT_COMPARISON', name: i18n?.translate('type.HAUSEFUL_EXIT_WITHOUT_COMPARISON')},
    { value: 'INSPECTION_ABANDONMENT_HAUSEFUL', name: i18n?.translate('type.INSPECTION_ABANDONMENT_HAUSEFUL')},
    { value: 'INSPECTION_GIACOMELLI_ENTRANCE', name: i18n?.translate('type.INSPECTION_GIACOMELLI_ENTRANCE')},
    { value: 'INSPECTION_GIACOMELLI_EXIT', name: i18n?.translate('type.INSPECTION_GIACOMELLI_EXIT')},
    { value: 'INSPECTION_PRELIMINARY', name: i18n?.translate('type.INSPECTION_PRELIMINARY')},
    { value: 'INSPECTION_PRELIMINARY_TYPE_ONE', name: i18n?.translate('type.INSPECTION_PRELIMINARY_TYPE_ONE')},
    { value: 'INSPECTION_PRELIMINARY_TYPE_TWO', name: i18n?.translate('type.INSPECTION_PRELIMINARY_TYPE_TWO')},
    { value: 'INSPECTION_PRELIMINARY_TYPE_THREE', name: i18n?.translate('type.INSPECTION_PRELIMINARY_TYPE_THREE')},
    { value: 'INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR', name: i18n?.translate('type.INSPECTION_ROUTINE_PLUS_VIRTUAL_TOUR')},
    { value: 'INSPECTION_INGOING_STUDIO', name: i18n?.translate('type.INSPECTION_INGOING_STUDIO')},
    { value: 'AIRBNB_CLEANING', name: i18n?.translate('type.AIRBNB_CLEANING')},
    { value: 'HEAVY_CLEANING_POST_CONSTRUCTION', name: i18n?.translate('type.HEAVY_CLEANING_POST_CONSTRUCTION')},
    { value: 'INSPECTION_ENTRANCE_BRASILIA_IMOVEIS', name: i18n?.translate('type.INSPECTION_ENTRANCE_BRASILIA_IMOVEIS') },
    { value: 'INSPECTION_EXIT_BRASILIA_IMOVEIS', name: i18n?.translate('type.INSPECTION_EXIT_BRASILIA_IMOVEIS') },
    { value: 'REINSPECTION_BRASILIA_IMOVEIS', name: i18n?.translate('type.REINSPECTION_BRASILIA_IMOVEIS') },
    { value: 'INSPECTION_ENTRANCE_NEGRAO', name: i18n?.translate('type.INSPECTION_ENTRANCE_NEGRAO') },
    { value: 'INSPECTION_EXIT_NEGRAO', name: i18n?.translate('type.INSPECTION_EXIT_NEGRAO') },
    { value: 'REINSPECTION_NEGRAO', name: i18n?.translate('type.REINSPECTION_NEGRAO') },
    { value: 'INSPECTION_ENTRANCE_LIGHT', name: i18n?.translate('type.INSPECTION_ENTRANCE_LIGHT') },
    { value: 'INSPECTION_EXIT_LIGHT_WITH_COMPARISON', name: i18n?.translate('type.INSPECTION_EXIT_LIGHT_WITH_COMPARISON') },
    { value: 'INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON', name: i18n?.translate('type.INSPECTION_EXIT_LIGHT_WITHOUT_COMPARISON') },
    { value: 'REINSPECTION_LIGHT', name: i18n?.translate('type.REINSPECTION_LIGHT') },
    { value: 'INSPECTION_ENTRANCE_LAVIERI', name: i18n?.translate('type.INSPECTION_ENTRANCE_LAVIERI') },
    { value: 'INSPECTION_EXIT_LAVIERI', name: i18n?.translate('type.INSPECTION_EXIT_LAVIERI') },
    { value: 'REINSPECTION_LAVIERI', name: i18n?.translate('type.REINSPECTION_LAVIERI') },
    { value: 'INSPECTION_ENTRANCE_SANTA_ILHA', name: i18n?.translate('type.INSPECTION_ENTRANCE_SANTA_ILHA') },
    { value: 'INSPECTION_EXIT_SANTA_ILHA', name: i18n?.translate('type.INSPECTION_EXIT_SANTA_ILHA') },
    { value: 'REINSPECTION_SANTA_ILHA', name: i18n?.translate('type.REINSPECTION_SANTA_ILHA') },
    { value: 'INSPECTION_ENTRANCE_DOMINAI', name: i18n?.translate('type.INSPECTION_ENTRANCE_DOMINAI') },
    { value: 'INSPECTION_EXIT_DOMINAI', name: i18n?.translate('type.INSPECTION_EXIT_DOMINAI') },
    { value: 'REINSPECTION_DOMINAI', name: i18n?.translate('type.REINSPECTION_DOMINAI') },
    { value: 'QUALITY_INSPECTION', name: i18n?.translate('type.QUALITY_INSPECTION') },
    { value: 'QUALITY_REINSPECTION', name: i18n?.translate('type.QUALITY_REINSPECTION') },
    { value: 'VISIT_CHARLIE', name: i18n?.translate('type.VISIT_CHARLIE') },
    { value: 'REPOSSESSION', name: i18n?.translate('type.REPOSSESSION') },
    { value: 'REGISTRATION_FORM', name: i18n?.translate('type.REGISTRATION_FORM') },
    { value: 'PROPERTY_CAPTURE', name: i18n?.translate('type.PROPERTY_CAPTURE') },
    { value: 'INSPECTION_ENTRANCE_CHARLIE', name: i18n?.translate('type.INSPECTION_ENTRANCE_CHARLIE') },
    { value: 'INSPECTION_EXIT_CHARLIE', name: i18n?.translate('type.INSPECTION_EXIT_CHARLIE') },
    { value: 'REGISTRATION_AUTHORITY_INSPECTION', name: i18n?.translate('type.REGISTRATION_AUTHORITY_INSPECTION') },
    { value: 'INSPECTION_EXIT_DL_WITH_COMPARISON', name: i18n?.translate('type.INSPECTION_EXIT_DL_WITH_COMPARISON') },
    { value: 'INSPECTION_PRELIMINARY_ROMA', name: i18n?.translate('type.INSPECTION_PRELIMINARY_ROMA') },
    { value: 'INSPECTION_PRELIMINARY_HAUSEFUL', name: i18n?.translate('type.INSPECTION_PRELIMINARY_HAUSEFUL') },
    { value: 'INSPECTION_DELIVERY_BUILDER', name: i18n?.translate('type.INSPECTION_DELIVERY_BUILDER') },
    { value: 'AGENDA_FORM', name: i18n?.translate('type.AGENDA_FORM') },
    { value: 'VISIT_IBAGY', name: i18n?.translate('type.VISIT_IBAGY') },
    { value: 'VISIT_RENASCENCA', name: i18n?.translate('type.VISIT_RENASCENCA') },
    { value: 'PROPERTY_CAPTURE_RENASCENCA', name: i18n?.translate('type.PROPERTY_CAPTURE_RENASCENCA') },
    { value: 'INSPECTION_DELIVERY_STANDARD', name: i18n?.translate('type.INSPECTION_DELIVERY_STANDARD') },
    { value: 'INSPECTION_DELIVERY_MEDIUM', name: i18n?.translate('type.INSPECTION_DELIVERY_MEDIUM') },
    { value: 'INSPECTION_DELIVERY_HIGH_STANDARD', name: i18n?.translate('type.INSPECTION_DELIVERY_HIGH_STANDARD') },
    { value: 'PREVENTIVE_RECORD', name: i18n?.translate('type.PREVENTIVE_RECORD') },
    { value: 'PREVENTIVE_RECORD_TYPE_ONE', name: i18n?.translate('type.PREVENTIVE_RECORD_TYPE_ONE') },
    { value: 'PREVENTIVE_RECORD_TYPE_TWO', name: i18n?.translate('type.PREVENTIVE_RECORD_TYPE_TWO') },
    { value: 'PREVENTIVE_RECORD_TYPE_THREE', name: i18n?.translate('type.PREVENTIVE_RECORD_TYPE_THREE') },
    { value: 'INSPECTION_ROUTINE_REPORT_PROPERFY', name: i18n?.translate('type.INSPECTION_ROUTINE_REPORT_PROPERFY') },
    { value: 'INSPECTION_NEUTRAL_MODEL_DOMINAI', name: i18n?.translate('type.INSPECTION_NEUTRAL_MODEL_DOMINAI') },
]

export const meetingLocations = [
    { value: 'REALTY', name: i18n?.translate('appointment.meetingLocation.REALTY') },
    { value: 'REAL_ESTATE', name: i18n?.translate('appointment.meetingLocation.REAL_ESTATE') },
    { value: 'OTHER', name: i18n?.translate('appointment.meetingLocation.OTHER') },
]

export const keyLocations = [
    { value: 'REAL_ESTATE', name: i18n?.translate('appointment.keyLocation.REAL_ESTATE') },
    { value: 'REALTY', name: i18n?.translate('appointment.keyLocation.REALTY') },
    { value: 'SMART_BOX', name: i18n?.translate('appointment.keyLocation.SMART_BOX') },
    { value: 'OWNER', name: i18n?.translate('appointment.keyLocation.OWNER') },
    { value: 'OTHER', name: i18n?.translate('appointment.keyLocation.OTHER') },
]

export const keyPickers = [
    { value: 'HOST', name: i18n?.translate('appointment.keyPicker.HOST') },
    { value: 'VISITOR', name: i18n?.translate('appointment.keyPicker.VISITOR') },
    { value: 'NOT_NEEDED', name: i18n?.translate('appointment.keyPicker.NOT_NEEDED') },
]

export const subscriptionTypes = [
    { name: 'Avulso', value: 'SINGLE_PURCHASE' },
    { name: '3 meses', value: 'SUBSCRIPTION_TRIMESTER' },
    { name: '6 meses', value: 'SUBSCRIPTION_SEMESTER' },
    { name: '9 meses', value: 'SUBSCRIPTION_NONAMESTER' },
    { name: '12 meses', value: 'SUBSCRIPTION_YEAR' },
    { name: 'Vitálicio', value: 'SUBSCRIPTION_LIFELONG' },
]

export const DDI = {
  br: '55',
  au: '61',
}

export const receiverType = [
  { value: 'HOST', name: i18n?.translate('transfer.receiverType.HOST') },
  { value: 'VENDOR', name: i18n?.translate('transfer.receiverType.VENDOR') },
  { value: 'PARTNER', name: i18n?.translate('transfer.receiverType.PARTNER') },
]

export const decimals = {
  decimal: ',',
  thousands: '',
  prefix: '',
  suffix: '',
  precision: 2,
}

export const paymentMethod = [
  { value: 'ASAAS_PIX', name: i18n?.translate('payment.type.ASAAS_PIX') },
  { value: 'ASAAS_BOLETO', name: i18n?.translate('payment.type.ASAAS_BOLETO') },
  { value: 'ASAAS_CREDIT_CARD', name: i18n?.translate('payment.type.ASAAS_CREDIT_CARD') },
  { value: 'VALUELESS', name: i18n?.translate('payment.type.VALUELESS') },
  { value: 'BALANCE', name: i18n?.translate('payment.type.BALANCE') },
]

export const transferMethodPreference = [
  { value: 'PIX', name: i18n?.translate('payment.transferMethodPreference.PIX') },
  { value: 'ASAAS', name: i18n?.translate('payment.transferMethodPreference.ASAAS') },
]

export const pixType = [
  { value: 'CPF', name: i18n?.translate('payment.pixType.CPF') },
  { value: 'CNPJ', name: i18n?.translate('payment.pixType.CNPJ') },
  { value: 'EMAIL', name: i18n?.translate('payment.pixType.EMAIL') },
  { value: 'PHONE', name: i18n?.translate('payment.pixType.PHONE') },
  { value: 'EVP', name: i18n?.translate('payment.pixType.EVP') },
]

export const realtyTypes = [
  { value: 'APARTMENT', name: i18n?.translate('realty.type.APARTMENT') },
  { value: 'HOUSE', name: i18n?.translate('realty.type.HOUSE') },
  { value: 'PENTHOUSE', name: i18n?.translate('realty.type.PENTHOUSE') },
  { value: 'GARAGE', name: i18n?.translate('realty.type.GARAGE') },
  { value: 'COMERCIAL', name: i18n?.translate('realty.type.COMERCIAL') },
  { value: 'KITNET', name: i18n?.translate('realty.type.KITNET') },
  { value: 'LOFT', name: i18n?.translate('realty.type.LOFT') },
  { value: 'STUDIO', name: i18n?.translate('realty.type.STUDIO') },
  { value: 'TWO_STORY_HOUSE', name: i18n?.translate('realty.type.TWO_STORY_HOUSE') },
  { value: 'LOT', name: i18n?.translate('realty.type.LOT') },
]

export const hausefulUsersTypes = [
  { value: 'ROLE_ADMIN', name: i18n?.translate('roles.ROLE_ADMIN') },
  { value: 'ROLE_SUPPORT', name: i18n?.translate('roles.ROLE_SUPPORT') },
  { value: 'ROLE_HAUSEFUL_FINANCIAL', name: i18n?.translate('roles.ROLE_HAUSEFUL_FINANCIAL') },
  { value: 'ROLE_PEOPLE', name: i18n?.translate('roles.ROLE_PEOPLE') },
  { value: 'ROLE_HAUSEFUL_OPERATOR', name: i18n?.translate('roles.ROLE_HAUSEFUL_OPERATOR') },
  { value: 'ROLE_PARTNER', name: i18n?.translate('roles.ROLE_PARTNER') },
  { value: 'ROLE_REAL_ESTATE', name: i18n?.translate('roles.ROLE_REAL_ESTATE') },
  { value: 'ROLE_REAL_ESTATE_OPERATOR', name: i18n?.translate('roles.ROLE_REAL_ESTATE_OPERATOR') },
]

export const countriesList = [
  {
    flag: '🇦🇺',
    value: 'AU',
    code: 'EN_US',
    language: 'English Australia',
    language_code: 'en-US',
    currency: 'AUSTRALIAN_DOLLAR',
    currency_code: 'AUD',
    currency_symbol: 'A$',
    currency_decimal: '.',
    currency_thousands: ',',
    currency_label: 'Australian Dollar',
    country: i18n?.translate('language.australia'),
  },
  {
    flag: '🇧🇷',
    value: 'BR',
    code: 'PT_BR',
    language: 'Português Brasil',
    language_code: 'pt-BR',
    currency: 'BRAZILIAN_REAL',
    currency_code: 'BRL',
    currency_symbol: 'R$',
    currency_decimal: ',',
    currency_thousands: '.',
    currency_label: 'Brazilian Real',
    country: i18n?.translate('language.brazil'),
  },
]

export const latLong = {
  US: { lat: -25, lng: 133 },
  AU: { lat: -25, lng: 133 },
  BR: { lat: -18, lng: -50 },
}

export const dialCodeList = [
  {
    name: 'Brazil',
    dial_code: '+55',
    code: ['BR', 'PT_BR'],
    flag: '🇧🇷',
  },
  {
    name: 'Australia',
    dial_code: '+61',
    code: ['AU', 'EN_AU', 'EN_US'],
    flag: '🇦🇺',
  },
  {
    name: 'Afghanistan',
    dial_code: '+93',
    code: ['AF'],
    flag: '🇦🇫',
  },
  {
    name: 'Åland Islands',
    dial_code: '+358',
    code: ['AX'],
    flag: '🇦🇽',
  },
  {
    name: 'Albania',
    dial_code: '+355',
    code: ['AL'],
    flag: '🇦🇱',
  },
  {
    name: 'Algeria',
    dial_code: '+213',
    code: ['DZ'],
    flag: '🇩🇿',
  },
  {
    name: 'American Samoa',
    dial_code: '+1684',
    code: ['AS'],
    flag: '🇦🇸',
  },
  {
    name: 'Andorra',
    dial_code: '+376',
    code: ['AD'],
    flag: '🇦🇩',
  },
  {
    name: 'Angola',
    dial_code: '+244',
    code: ['AO'],
    flag: '🇦🇴',
  },
  {
    name: 'Anguilla',
    dial_code: '+1264',
    code: ['AI'],
    flag: '🇦🇮',
  },
  {
    name: 'Antarctica',
    dial_code: '+672',
    code: ['AQ'],
    flag: '🇦🇶',
  },
  {
    name: 'Antigua and Barbuda',
    dial_code: '+1268',
    code: ['AG'],
    flag: '🇦🇬',
  },
  {
    name: 'Argentina',
    dial_code: '+54',
    code: ['AR'],
    flag: '🇦🇷',
  },
  {
    name: 'Armenia',
    dial_code: '+374',
    code: ['AM'],
    flag: '🇦🇲',
  },
  {
    name: 'Aruba',
    dial_code: '+297',
    code: ['AW'],
    flag: '🇦🇼',
  },
  {
    name: 'Austria',
    dial_code: '+43',
    code: ['AT'],
    flag: '🇦🇹',
  },
  {
    name: 'Azerbaijan',
    dial_code: '+994',
    code: ['AZ'],
    flag: '🇦🇿',
  },
  {
    name: 'Bahamas',
    dial_code: '+1242',
    code: ['BS'],
    flag: '🇧🇸',
  },
  {
    name: 'Bahrain',
    dial_code: '+973',
    code: ['BH'],
    flag: '🇧🇭',
  },
  {
    name: 'Bangladesh',
    dial_code: '+880',
    code: ['BD'],
    flag: '🇧🇩',
  },
  {
    name: 'Barbados',
    dial_code: '+1246',
    code: ['BB'],
    flag: '🇧🇧',
  },
  {
    name: 'Belarus',
    dial_code: '+375',
    code: ['BY'],
    flag: '🇧🇾',
  },
  {
    name: 'Belgium',
    dial_code: '+32',
    code: ['BE'],
    flag: '🇧🇪',
  },
  {
    name: 'Belize',
    dial_code: '+501',
    code: ['BZ'],
    flag: '🇧🇿',
  },
  {
    name: 'Benin',
    dial_code: '+229',
    code: ['BJ'],
    flag: '🇧🇯',
  },
  {
    name: 'Bermuda',
    dial_code: '+1441',
    code: ['BM'],
    flag: '🇧🇲',
  },
  {
    name: 'Bhutan',
    dial_code: '+975',
    code: ['BT'],
    flag: '🇧🇹',
  },
  {
    name: 'Bolivia, Plurinational State of bolivia',
    dial_code: '+591',
    code: ['BO'],
    flag: '🇧🇴',
  },
  {
    name: 'Bosnia and Herzegovina',
    dial_code: '+387',
    code: ['BA'],
    flag: '🇧🇦',
  },
  {
    name: 'Botswana',
    dial_code: '+267',
    code: ['BW'],
    flag: '🇧🇼',
  },
  {
    name: 'Bouvet Island',
    dial_code: '+47',
    code: ['BV'],
    flag: '🏳',
  },
  {
    name: 'British Indian Ocean Territory',
    dial_code: '+246',
    code: ['IO'],
    flag: '🇮🇴',
  },
  {
    name: 'Brunei Darussalam',
    dial_code: '+673',
    code: ['BN'],
    flag: '🇧🇳',
  },
  {
    name: 'Bulgaria',
    dial_code: '+359',
    code: ['BG'],
    flag: '🇧🇬',
  },
  {
    name: 'Burkina Faso',
    dial_code: '+226',
    code: ['BF'],
    flag: '🇧🇫',
  },
  {
    name: 'Burundi',
    dial_code: '+257',
    code: ['BI'],
    flag: '🇧🇮',
  },
  {
    name: 'Cambodia',
    dial_code: '+855',
    code: ['KH'],
    flag: '🇰🇭',
  },
  {
    name: 'Cameroon',
    dial_code: '+237',
    code: ['CM'],
    flag: '🇨🇲',
  },
  {
    name: 'Canada',
    dial_code: '+1',
    code: ['CA'],
    flag: '🇨🇦',
  },
  {
    name: 'Cape Verde',
    dial_code: '+238',
    code: ['CV'],
    flag: '🇨🇻',
  },
  {
    name: 'Cayman Islands',
    dial_code: '+ 345',
    code: ['KY'],
    flag: '🇰🇾',
  },
  {
    name: 'Central African Republic',
    dial_code: '+236',
    code: ['CF'],
    flag: '🇨🇫',
  },
  {
    name: 'Chad',
    dial_code: '+235',
    code: ['TD'],
    flag: '🇹🇩',
  },
  {
    name: 'Chile',
    dial_code: '+56',
    code: ['CL'],
    flag: '🇨🇱',
  },
  {
    name: 'China',
    dial_code: '+86',
    code: ['CN'],
    flag: '🇨🇳',
  },
  {
    name: 'Christmas Island',
    dial_code: '+61',
    code: ['CX'],
    flag: '🇨🇽',
  },
  {
    name: 'Cocos (Keeling) Islands',
    dial_code: '+61',
    code: ['CC'],
    flag: '🇨🇨',
  },
  {
    name: 'Colombia',
    dial_code: '+57',
    code: ['CO'],
    flag: '🇨🇴',
  },
  {
    name: 'Comoros',
    dial_code: '+269',
    code: ['KM'],
    flag: '🇰🇲',
  },
  {
    name: 'Congo',
    dial_code: '+242',
    code: ['CG'],
    flag: '🇨🇬',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    dial_code: '+243',
    code: ['CD'],
    flag: '🇨🇩',
  },
  {
    name: 'Cook Islands',
    dial_code: '+682',
    code: ['CK'],
    flag: '🇨🇰',
  },
  {
    name: 'Costa Rica',
    dial_code: '+506',
    code: ['CR'],
    flag: '🇨🇷',
  },
  {
    name: "Cote d'Ivoire",
    dial_code: '+225',
    code: ['CI'],
    flag: '🇨🇮',
  },
  {
    name: 'Croatia',
    dial_code: '+385',
    code: ['HR'],
    flag: '🇭🇷',
  },
  {
    name: 'Cuba',
    dial_code: '+53',
    code: ['CU'],
    flag: '🇨🇺',
  },
  {
    name: 'Cyprus',
    dial_code: '+357',
    code: ['CY'],
    flag: '🇨🇾',
  },
  {
    name: 'Czech Republic',
    dial_code: '+420',
    code: ['CZ'],
    flag: '🇨🇿',
  },
  {
    name: 'Denmark',
    dial_code: '+45',
    code: ['DK'],
    flag: '🇩🇰',
  },
  {
    name: 'Djibouti',
    dial_code: '+253',
    code: ['DJ'],
    flag: '🇩🇯',
  },
  {
    name: 'Dominica',
    dial_code: '+1767',
    code: ['DM'],
    flag: '🇩🇲',
  },
  {
    name: 'Dominican Republic',
    dial_code: '+1849',
    code: ['DO'],
    flag: '🇨🇩',
  },
  {
    name: 'Ecuador',
    dial_code: '+593',
    code: ['EC'],
    flag: '🇪🇨',
  },
  {
    name: 'Egypt',
    dial_code: '+20',
    code: ['EG'],
    flag: '🇪🇬',
  },
  {
    name: 'El Salvador',
    dial_code: '+503',
    code: ['SV'],
    flag: '🇸🇻',
  },
  {
    name: 'Equatorial Guinea',
    dial_code: '+240',
    code: ['GQ'],
    flag: '🇬🇶',
  },
  {
    name: 'Eritrea',
    dial_code: '+291',
    code: ['ER'],
    flag: '🇪🇷',
  },
  {
    name: 'Estonia',
    dial_code: '+372',
    code: ['EE'],
    flag: '🇪🇪',
  },
  {
    name: 'Ethiopia',
    dial_code: '+251',
    code: ['ET'],
    flag: '🇪🇹',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    dial_code: '+500',
    code: ['FK'],
    flag: '🇫🇰',
  },
  {
    name: 'Faroe Islands',
    dial_code: '+298',
    code: ['FO'],
    flag: '🇫🇴',
  },
  {
    name: 'Fiji',
    dial_code: '+679',
    code: ['FJ'],
    flag: '🇫🇯',
  },
  {
    name: 'Finland',
    dial_code: '+358',
    code: ['FI'],
    flag: '🇫🇮',
  },
  {
    name: 'France',
    dial_code: '+33',
    code: ['FR'],
    flag: '🇫🇷',
  },
  {
    name: 'French Guiana',
    dial_code: '+594',
    code: ['GF'],
    flag: '🇬🇫',
  },
  {
    name: 'French Polynesia',
    dial_code: '+689',
    code: ['PF'],
    flag: '🇵🇫',
  },
  {
    name: 'French Southern Territories',
    dial_code: '+262',
    code: ['TF'],
    flag: '🇹🇫',
  },
  {
    name: 'Gabon',
    dial_code: '+241',
    code: ['GA'],
    flag: '🇬🇦',
  },
  {
    name: 'Gambia',
    dial_code: '+220',
    code: ['GM'],
    flag: '🇬🇲',
  },
  {
    name: 'Georgia',
    dial_code: '+995',
    code: ['GE'],
    flag: '🇬🇪',
  },
  {
    name: 'Germany',
    dial_code: '+49',
    code: ['DE'],
    flag: '🇩🇪',
  },
  {
    name: 'Ghana',
    dial_code: '+233',
    code: ['GH'],
    flag: '🇬🇭',
  },
  {
    name: 'Gibraltar',
    dial_code: '+350',
    code: ['GI'],
    flag: '🇬🇮',
  },
  {
    name: 'Greece',
    dial_code: '+30',
    code: ['GR'],
    flag: '🇬🇷',
  },
  {
    name: 'Greenland',
    dial_code: '+299',
    code: ['GL'],
    flag: '🇬🇱',
  },
  {
    name: 'Grenada',
    dial_code: '+1473',
    code: ['GD'],
    flag: '🇬🇩',
  },
  {
    name: 'Guadeloupe',
    dial_code: '+590',
    code: ['GP'],
    flag: '🇬🇵',
  },
  {
    name: 'Guam',
    dial_code: '+1671',
    code: ['GU'],
    flag: '🇬🇺',
  },
  {
    name: 'Guatemala',
    dial_code: '+502',
    code: ['GT'],
    flag: '🇬🇹',
  },
  {
    name: 'Guernsey',
    dial_code: '+44',
    code: ['GG'],
    flag: '🇬🇬',
  },
  {
    name: 'Guinea',
    dial_code: '+224',
    code: ['GN'],
    flag: '🇬🇳',
  },
  {
    name: 'Guinea-Bissau',
    dial_code: '+245',
    code: ['GW'],
    flag: '🇬🇼',
  },
  {
    name: 'Guyana',
    dial_code: '+592',
    code: ['GY'],
    flag: '🇬🇾',
  },
  {
    name: 'Haiti',
    dial_code: '+509',
    code: ['HT'],
    flag: '🇭🇹',
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    dial_code: '+0',
    code: ['HM'],
    flag: '🏳',
  },
  {
    name: 'Holy See (Vatican City State)',
    dial_code: '+379',
    code: ['VA'],
    flag: '🇻🇦',
  },
  {
    name: 'Honduras',
    dial_code: '+504',
    code: ['HN'],
    flag: '🇭🇳',
  },
  {
    name: 'Hong Kong',
    dial_code: '+852',
    code: ['HK'],
    flag: '🇭🇰',
  },
  {
    name: 'Hungary',
    dial_code: '+36',
    code: ['HU'],
    flag: '🇭🇺',
  },
  {
    name: 'Iceland',
    dial_code: '+354',
    code: ['IS'],
    flag: '🇮🇸',
  },
  {
    name: 'India',
    dial_code: '+91',
    code: ['IN'],
    flag: '🇮🇳',
  },
  {
    name: 'Indonesia',
    dial_code: '+62',
    code: ['ID'],
    flag: '🇮🇩',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    dial_code: '+98',
    code: ['IR'],
    flag: '🇮🇷',
  },
  {
    name: 'Iraq',
    dial_code: '+964',
    code: ['IQ'],
    flag: '🇮🇶',
  },
  {
    name: 'Ireland',
    dial_code: '+353',
    code: ['IE'],
    flag: '🇮🇪',
  },
  {
    name: 'Isle of Man',
    dial_code: '+44',
    code: ['IM'],
    flag: '🇮🇲',
  },
  {
    name: 'Israel',
    dial_code: '+972',
    code: ['IL'],
    flag: '🇮🇱',
  },
  {
    name: 'Italy',
    dial_code: '+39',
    code: ['IT'],
    flag: '🇮🇹',
  },
  {
    name: 'Jamaica',
    dial_code: '+1876',
    code: ['JM'],
    flag: '🇯🇲',
  },
  {
    name: 'Japan',
    dial_code: '+81',
    code: ['JP'],
    flag: '🇯🇵',
  },
  {
    name: 'Jersey',
    dial_code: '+44',
    code: ['JE'],
    flag: '🇯🇪',
  },
  {
    name: 'Jordan',
    dial_code: '+962',
    code: ['JO'],
    flag: '🇯🇴',
  },
  {
    name: 'Kazakhstan',
    dial_code: '+7',
    code: ['KZ'],
    flag: '🇰🇿',
  },
  {
    name: 'Kenya',
    dial_code: '+254',
    code: ['KE'],
    flag: '🇰🇪',
  },
  {
    name: 'Kiribati',
    dial_code: '+686',
    code: ['KI'],
    flag: '🇰🇮',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: '+850',
    code: ['KP'],
    flag: '🇰🇵',
  },
  {
    name: 'Korea, Republic of South Korea',
    dial_code: '+82',
    code: ['KR'],
    flag: '🇰🇷',
  },
  {
    name: 'Kosovo',
    dial_code: '+383',
    code: ['XK'],
    flag: '🇽🇰',
  },
  {
    name: 'Kuwait',
    dial_code: '+965',
    code: ['KW'],
    flag: '🇰🇼',
  },
  {
    name: 'Kyrgyzstan',
    dial_code: '+996',
    code: ['KG'],
    flag: '🇰🇬',
  },
  {
    name: 'Laos',
    dial_code: '+856',
    code: ['LA'],
    flag: '🇱🇦',
  },
  {
    name: 'Latvia',
    dial_code: '+371',
    code: ['LV'],
    flag: '🇱🇻',
  },
  {
    name: 'Lebanon',
    dial_code: '+961',
    code: ['LB'],
    flag: '🇱🇧',
  },
  {
    name: 'Lesotho',
    dial_code: '+266',
    code: ['LS'],
    flag: '🇱🇸',
  },
  {
    name: 'Liberia',
    dial_code: '+231',
    code: ['LR'],
    flag: '🇱🇷',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    dial_code: '+218',
    code: ['LY'],
    flag: '🇱🇾',
  },
  {
    name: 'Liechtenstein',
    dial_code: '+423',
    code: ['LI'],
    flag: '🇱🇮',
  },
  {
    name: 'Lithuania',
    dial_code: '+370',
    code: ['LT'],
    flag: '🇱🇹',
  },
  {
    name: 'Luxembourg',
    dial_code: '+352',
    code: ['LU'],
    flag: '🇱🇺',
  },
  {
    name: 'Macao',
    dial_code: '+853',
    code: ['MO'],
    flag: '🇲🇴',
  },
  {
    name: 'Macedonia',
    dial_code: '+389',
    code: ['MK'],
    flag: '🇲🇰',
  },
  {
    name: 'Madagascar',
    dial_code: '+261',
    code: ['MG'],
    flag: '🇲🇬',
  },
  {
    name: 'Malawi',
    dial_code: '+265',
    code: ['MW'],
    flag: '🇲🇼',
  },
  {
    name: 'Malaysia',
    dial_code: '+60',
    code: ['MY'],
    flag: '🇲🇾',
  },
  {
    name: 'Maldives',
    dial_code: '+960',
    code: ['MV'],
    flag: '🇲🇻',
  },
  {
    name: 'Mali',
    dial_code: '+223',
    code: ['ML'],
    flag: '🇲🇱',
  },
  {
    name: 'Malta',
    dial_code: '+356',
    code: ['MT'],
    flag: '🇲🇹',
  },
  {
    name: 'Marshall Islands',
    dial_code: '+692',
    code: ['MH'],
    flag: '🇲🇭',
  },
  {
    name: 'Martinique',
    dial_code: '+596',
    code: ['MQ'],
    flag: '🇲🇶',
  },
  {
    name: 'Mauritania',
    dial_code: '+222',
    code: ['MR'],
    flag: '🇲🇷',
  },
  {
    name: 'Mauritius',
    dial_code: '+230',
    code: ['MU'],
    flag: '🇲🇺',
  },
  {
    name: 'Mayotte',
    dial_code: '+262',
    code: ['YT'],
    flag: '🇾🇹',
  },
  {
    name: 'Mexico',
    dial_code: '+52',
    code: ['MX'],
    flag: '🇲🇽',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    dial_code: '+691',
    code: ['FM'],
    flag: '🇫🇲',
  },
  {
    name: 'Moldova',
    dial_code: '+373',
    code: ['MD'],
    flag: '🇲🇩',
  },
  {
    name: 'Monaco',
    dial_code: '+377',
    code: ['MC'],
    flag: '🇲🇨',
  },
  {
    name: 'Mongolia',
    dial_code: '+976',
    code: ['MN'],
    flag: '🇲🇳',
  },
  {
    name: 'Montenegro',
    dial_code: '+382',
    code: ['ME'],
    flag: '🇲🇪',
  },
  {
    name: 'Montserrat',
    dial_code: '+1664',
    code: ['MS'],
    flag: '🇲🇸',
  },
  {
    name: 'Morocco',
    dial_code: '+212',
    code: ['MA'],
    flag: '🇲🇦',
  },
  {
    name: 'Mozambique',
    dial_code: '+258',
    code: ['MZ'],
    flag: '🇲🇿',
  },
  {
    name: 'Myanmar',
    dial_code: '+95',
    code: ['MM'],
    flag: '🇲🇲',
  },
  {
    name: 'Namibia',
    dial_code: '+264',
    code: ['NA'],
    flag: '🇳🇦',
  },
  {
    name: 'Nauru',
    dial_code: '+674',
    code: ['NR'],
    flag: '🇳🇷',
  },
  {
    name: 'Nepal',
    dial_code: '+977',
    code: ['NP'],
    flag: '🇳🇵',
  },
  {
    name: 'Netherlands',
    dial_code: '+31',
    code: ['NL'],
    flag: '🇳🇱',
  },
  {
    name: 'Netherlands Antilles',
    dial_code: '+599',
    code: ['AN'],
    flag: '🇳🇱',
  },
  {
    name: 'New Caledonia',
    dial_code: '+687',
    code: ['NC'],
    flag: '🇳🇨',
  },
  {
    name: 'New Zealand',
    dial_code: '+64',
    code: ['NZ'],
    flag: '🇳🇿',
  },
  {
    name: 'Nicaragua',
    dial_code: '+505',
    code: ['NI'],
    flag: '🇳🇮',
  },
  {
    name: 'Niger',
    dial_code: '+227',
    code: ['NE'],
    flag: '🇳🇪',
  },
  {
    name: 'Nigeria',
    dial_code: '+234',
    code: ['NG'],
    flag: '🇳🇬',
  },
  {
    name: 'Niue',
    dial_code: '+683',
    code: ['NU'],
    flag: '🇳🇺',
  },
  {
    name: 'Norfolk Island',
    dial_code: '+672',
    code: ['NF'],
    flag: '🇳🇫',
  },
  {
    name: 'Northern Mariana Islands',
    dial_code: '+1670',
    code: ['MP'],
    flag: '🏳',
  },
  {
    name: 'Norway',
    dial_code: '+47',
    code: ['NO'],
    flag: '🇳🇴',
  },
  {
    name: 'Oman',
    dial_code: '+968',
    code: ['OM'],
    flag: '🇴🇲',
  },
  {
    name: 'Pakistan',
    dial_code: '+92',
    code: ['PK'],
    flag: '🇵🇰',
  },
  {
    name: 'Palau',
    dial_code: '+680',
    code: ['PW'],
    flag: '🇵🇼',
  },
  {
    name: 'Palestinian Territory, Occupied',
    dial_code: '+970',
    code: ['PS'],
    flag: '🇵🇸',
  },
  {
    name: 'Panama',
    dial_code: '+507',
    code: ['PA'],
    flag: '🇵🇦',
  },
  {
    name: 'Papua New Guinea',
    dial_code: '+675',
    code: ['PG'],
    flag: '🇵🇬',
  },
  {
    name: 'Paraguay',
    dial_code: '+595',
    code: ['PY'],
    flag: '🇵🇾',
  },
  {
    name: 'Peru',
    dial_code: '+51',
    code: ['PE'],
    flag: '🇵🇪',
  },
  {
    name: 'Philippines',
    dial_code: '+63',
    code: ['PH'],
    flag: '🇵🇭',
  },
  {
    name: 'Pitcairn',
    dial_code: '+64',
    code: ['PN'],
    flag: '🇵🇳',
  },
  {
    name: 'Poland',
    dial_code: '+48',
    code: ['PL'],
    flag: '🇵🇱',
  },
  {
    name: 'Portugal',
    dial_code: '+351',
    code: ['PT'],
    flag: '🇵🇹',
  },
  {
    name: 'Puerto Rico',
    dial_code: '+1939',
    code: ['PR'],
    flag: '🇵🇷',
  },
  {
    name: 'Qatar',
    dial_code: '+974',
    code: ['QA'],
    flag: '🇶🇦',
  },
  {
    name: 'Romania',
    dial_code: '+40',
    code: ['RO'],
    flag: '🇷🇴',
  },
  {
    name: 'Russia',
    dial_code: '+7',
    code: ['RU'],
    flag: '🇷🇺',
  },
  {
    name: 'Rwanda',
    dial_code: '+250',
    code: ['RW'],
    flag: '🇷🇼',
  },
  {
    name: 'Reunion',
    dial_code: '+262',
    code: ['RE'],
    flag: '🇫🇷',
  },
  {
    name: 'Saint Barthelemy',
    dial_code: '+590',
    code: ['BL'],
    flag: '🇧🇱',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    dial_code: '+290',
    code: ['SH'],
    flag: '🇸🇭',
  },
  {
    name: 'Saint Kitts and Nevis',
    dial_code: '+1869',
    code: ['KN'],
    flag: '🇰🇳',
  },
  {
    name: 'Saint Lucia',
    dial_code: '+1758',
    code: ['LC'],
    flag: '🇱🇨',
  },
  {
    name: 'Saint Martin',
    dial_code: '+590',
    code: ['MF'],
    flag: '🏳',
  },
  {
    name: 'Saint Pierre and Miquelon',
    dial_code: '+508',
    code: ['PM'],
    flag: '🇵🇲',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    dial_code: '+1784',
    code: ['VC'],
    flag: '🇻🇨',
  },
  {
    name: 'Samoa',
    dial_code: '+685',
    code: ['WS'],
    flag: '🇼🇸',
  },
  {
    name: 'San Marino',
    dial_code: '+378',
    code: ['SM'],
    flag: '🇸🇲',
  },
  {
    name: 'Sao Tome and Principe',
    dial_code: '+239',
    code: ['ST'],
    flag: '🇸🇹',
  },
  {
    name: 'Saudi Arabia',
    dial_code: '+966',
    code: ['SA'],
    flag: '🇸🇦',
  },
  {
    name: 'Senegal',
    dial_code: '+221',
    code: ['SN'],
    flag: '🇸🇳',
  },
  {
    name: 'Serbia',
    dial_code: '+381',
    code: ['RS'],
    flag: '🇷🇸',
  },
  {
    name: 'Seychelles',
    dial_code: '+248',
    code: ['SC'],
    flag: '🇸🇨',
  },
  {
    name: 'Sierra Leone',
    dial_code: '+232',
    code: ['SL'],
    flag: '🇸🇱',
  },
  {
    name: 'Singapore',
    dial_code: '+65',
    code: ['SG'],
    flag: '🇸🇬',
  },
  {
    name: 'Slovakia',
    dial_code: '+421',
    code: ['SK'],
    flag: '🇸🇰',
  },
  {
    name: 'Slovenia',
    dial_code: '+386',
    code: ['SI'],
    flag: '🇸🇮',
  },
  {
    name: 'Solomon Islands',
    dial_code: '+677',
    code: ['SB'],
    flag: '🇸🇧',
  },
  {
    name: 'Somalia',
    dial_code: '+252',
    code: ['SO'],
    flag: '🇸🇴',
  },
  {
    name: 'South Africa',
    dial_code: '+27',
    code: ['ZA'],
    flag: '🇿🇦',
  },
  {
    name: 'South Sudan',
    dial_code: '+211',
    code: ['SS'],
    flag: '🇸🇸',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    dial_code: '+500',
    code: ['GS'],
    flag: '🇬🇸',
  },
  {
    name: 'Spain',
    dial_code: '+34',
    code: ['ES'],
    flag: '🇪🇸',
  },
  {
    name: 'Sri Lanka',
    dial_code: '+94',
    code: ['LK'],
    flag: '🇱🇰',
  },
  {
    name: 'Sudan',
    dial_code: '+249',
    code: ['SD'],
    flag: '🇸🇩',
  },
  {
    name: 'Suriname',
    dial_code: '+597',
    code: ['SR'],
    flag: '🇸🇷',
  },
  {
    name: 'Svalbard and Jan Mayen',
    dial_code: '+47',
    code: ['SJ'],
    flag: '🇩🇰',
  },
  {
    name: 'Swaziland',
    dial_code: '+268',
    code: ['SZ'],
    flag: '🇸🇿',
  },
  {
    name: 'Sweden',
    dial_code: '+46',
    code: ['SE'],
    flag: '🇸🇪',
  },
  {
    name: 'Switzerland',
    dial_code: '+41',
    code: ['CH'],
    flag: '🇨🇭',
  },
  {
    name: 'Syrian Arab Republic',
    dial_code: '+963',
    code: ['SY'],
    flag: '🇸🇾',
  },
  {
    name: 'Taiwan',
    dial_code: '+886',
    code: ['TW'],
    flag: '🇹🇼',
  },
  {
    name: 'Tajikistan',
    dial_code: '+992',
    code: ['TJ'],
    flag: '🇹🇯',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    dial_code: '+255',
    code: ['TZ'],
    flag: '🇹🇿',
  },
  {
    name: 'Thailand',
    dial_code: '+66',
    code: ['TH'],
    flag: '🇹🇭',
  },
  {
    name: 'Timor-Leste',
    dial_code: '+670',
    code: ['TL'],
    flag: '🇹🇱',
  },
  {
    name: 'Togo',
    dial_code: '+228',
    code: ['TG'],
    flag: '🇹🇬',
  },
  {
    name: 'Tokelau',
    dial_code: '+690',
    code: ['TK'],
    flag: '🇹🇰',
  },
  {
    name: 'Tonga',
    dial_code: '+676',
    code: ['TO'],
    flag: '🇹🇴',
  },
  {
    name: 'Trinidad and Tobago',
    dial_code: '+1868',
    code: ['TT'],
    flag: '🇹🇹',
  },
  {
    name: 'Tunisia',
    dial_code: '+216',
    code: ['TN'],
    flag: '🇹🇳',
  },
  {
    name: 'Turkey',
    dial_code: '+90',
    code: ['TR'],
    flag: '🇹🇷',
  },
  {
    name: 'Turkmenistan',
    dial_code: '+993',
    code: ['TM'],
    flag: '🇹🇲',
  },
  {
    name: 'Turks and Caicos Islands',
    dial_code: '+1649',
    code: ['TC'],
    flag: '🇹🇨',
  },
  {
    name: 'Tuvalu',
    dial_code: '+688',
    code: ['TV'],
    flag: '🇹🇻',
  },
  {
    name: 'Uganda',
    dial_code: '+256',
    code: ['UG'],
    flag: '🇺🇬',
  },
  {
    name: 'Ukraine',
    dial_code: '+380',
    code: ['UA'],
    flag: '🇺🇦',
  },
  {
    name: 'United Arab Emirates',
    dial_code: '+971',
    code: ['AE'],
    flag: '🇦🇪',
  },
  {
    name: 'United Kingdom',
    dial_code: '+44',
    code: ['GB'],
    flag: '🇬🇧',
  },
  {
    name: 'United States',
    dial_code: '+1',
    code: ['US', 'en-US'],
    flag: '🇺🇸',
  },
  {
    name: 'Uruguay',
    dial_code: '+598',
    code: ['UY'],
    flag: '🇺🇾',
  },
  {
    name: 'Uzbekistan',
    dial_code: '+998',
    code: ['UZ'],
    flag: '🇺🇿',
  },
  {
    name: 'Vanuatu',
    dial_code: '+678',
    code: ['VU'],
    flag: '🇻🇺',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    dial_code: '+58',
    code: ['VE'],
    flag: '🇻🇪',
  },
  {
    name: 'Vietnam',
    dial_code: '+84',
    code: ['VN'],
    flag: '🇻🇳',
  },
  {
    name: 'Virgin Islands, British',
    dial_code: '+1284',
    code: ['VG'],
    flag: '🇻🇬',
  },
  {
    name: 'Virgin Islands, U.S.',
    dial_code: '+1340',
    code: ['VI'],
    flag: '🇻🇮',
  },
  {
    name: 'Wallis and Futuna',
    dial_code: '+681',
    code: ['WF'],
    flag: '🇼🇫',
  },
  {
    name: 'Yemen',
    dial_code: '+967',
    code: ['YE'],
    flag: '🇾🇪',
  },
  {
    name: 'Zambia',
    dial_code: '+260',
    code: ['ZM'],
    flag: '🇿🇲',
  },
  {
    name: 'Zimbabwe',
    dial_code: '+263',
    code: ['ZW'],
    flag: '🇿🇼',
  },
]

export const appointmentPartnerStatus = [
  {
    value: 'DRAFT',
    label: i18n?.translate('appointment.status.DRAFT')
  },
  {
    value: 'REJECTED',
    label: i18n?.translate('appointment.status.REJECTED')
  },
  {
    value: 'OPEN',
    label: i18n?.translate('appointment.status.OPEN')
  },
  {
    value: 'SCHEDULED',
    label: i18n?.translate('appointment.status.SCHEDULED')
  }
]

export const groupPartnerStatus = [
  {
    value: 'OPEN',
    label: i18n?.translate('appointment.status.OPEN')
  },
  {
    value: 'ACCEPTED',
    label: i18n?.translate('appointment.status.ACCEPTED')
  },
  {
    value: 'DONE',
    label: i18n?.translate('appointment.status.DONE')
  },
  {
    value: 'CANCELED',
    label: i18n?.translate('appointment.status.CANCELED')
  },
]

export const workerType = [
  {
    value: 'HOST',
    label: i18n?.translate('appointment.workerType.HOST')
  },
  {
    value: 'INTERNAL',
    label: i18n?.translate('appointment.workerType.INTERNAL')
  },
  {
    value: 'THIRD_PARTY',
    label: i18n?.translate('appointment.workerType.THIRD_PARTY')
  },
]

export const workerTypeOptions = [
  {
    hide: false,
    value: 'HOST',
    text: i18n?.translate('operationTypes.options.host.text'),
    description: i18n?.translate('operationTypes.options.host.description'),
  },
  {
    hide: false,
    value: 'INTERNAL',
    text: i18n?.translate('operationTypes.options.internal.text'),
    description: i18n?.translate('operationTypes.options.internal.description'),
  },
]

export const serviceDurationValidationTypeOptions = [
  {
    value: 'DEFAULT',
    text: i18n?.translate('customer.create.serviceDurationValidationType.options.default'),
  },
  {
    value: 'STRICT_DURATION',
    text: i18n?.translate('customer.create.serviceDurationValidationType.options.strictDuration'),
  },
]
